import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import Select from 'antd/lib/select';
import { registerUser } from '../api/auth';
import FooterBar from '../components/helpdesk/FooterBar';
import HeaderBar from '../components/helpdesk/HeaderBar';
import '../styles/helpdesk.scss';

const roleOptions = [
  { label: 'Admin', value: 'ADMIN' },
  { label: 'Editor', value: 'EDITOR' },
  { label: 'Author', value: 'AUTHOR' },
];

function CreateUserPage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await registerUser(values);
      message.success('User created successfully.');
      navigate('/admin/users');
    } catch {
      message.error('Unable to create user.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="helpdesk-page">
      <HeaderBar />
      <main className="helpdesk-main">
        <div className="helpdesk-main__inner">
          <section className="create-user-page" aria-label="Create user form">
            <button type="button" className="create-article__back" onClick={() => navigate(-1)}>
              {'<-'} Go Back
            </button>

            <section className="create-article create-user-form-shell">
              <header className="create-article__header">
                <h1>Create New User</h1>
                <button
                  type="button"
                  aria-label="Close"
                  className="create-article__close"
                  onClick={() => navigate('/admin/users')}
                >
                  x
                </button>
              </header>

              <Form
                form={form}
                layout="vertical"
                requiredMark={false}
                className="create-article__form create-user-form"
                initialValues={{ role: 'AUTHOR' }}
                onFinish={handleSubmit}
              >
                <div className="create-article__row">
                  <Form.Item
                    label="Name *"
                    name="name"
                    rules={[{ required: true, message: 'Please enter name.' }]}
                  >
                    <Input placeholder="Alex Morgan" />
                  </Form.Item>
                  <Form.Item
                    label="Email *"
                    name="email"
                    rules={[
                      { required: true, message: 'Please enter email.' },
                      { type: 'email', message: 'Please enter valid email.' },
                    ]}
                  >
                    <Input placeholder="alex@example.com" />
                  </Form.Item>
                </div>

                <div className="create-article__row">
                  <Form.Item
                    label="Password *"
                    name="password"
                    rules={[{ required: true, message: 'Please enter password.' }]}
                  >
                    <Input.Password placeholder="StrongPass123!" />
                  </Form.Item>
                  <Form.Item
                    label="Role *"
                    name="role"
                    rules={[{ required: true, message: 'Please select role.' }]}
                  >
                    <Select options={roleOptions} />
                  </Form.Item>
                </div>

                <div className="create-article__actions">
                  <Button onClick={() => navigate('/admin/users')} disabled={submitting}>
                    Cancel
                  </Button>
                  <Button type="primary" htmlType="submit" loading={submitting}>
                    Create User
                  </Button>
                </div>
              </Form>
            </section>
          </section>
        </div>
      </main>
      <FooterBar />
    </div>
  );
}

export default CreateUserPage;
